import { motion } from "framer-motion";
import { Star } from "lucide-react";

const REVIEWS = [
  {
    name: "Srinivas R.",
    car: "Hyundai Creta",
    text: "They showed me the genuine part packaging and hologram before fitting it, and returned my old brake pads. Never seen this transparency at any garage in Hyderabad.",
  },
  {
    name: "Ayesha K.",
    car: "Maruti Baleno",
    text: "Insurance claim was completely cashless and stress-free. AutoHQ handled the surveyor, paperwork, everything. Got my car back looking brand new.",
  },
  {
    name: "Vikram T.",
    car: "Tata Nexon",
    text: "Live photo updates while my car was being serviced. Transparent estimate, no surprise charges, and free pickup from Begumpet. Highly recommended.",
  },
];

export default function Testimonials() {
  return (
    <section className="py-16 sm:py-28 px-5 lg:px-8 bg-[#F5F5F7] border-y border-[#E4E4E7]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs uppercase tracking-[0.25em] text-[#FF5A00] font-bold mb-3">Customer Stories</p>
        <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-[#0A0A0A]">
          5,000+ Cars. <span className="text-[#FF5A00]">Zero Compromises.</span>
        </h2>
        <div className="mt-10 grid md:grid-cols-3 gap-4">
          {REVIEWS.map((r, i) => (
            <motion.div
              key={r.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="bg-white border border-[#E4E4E7] rounded-sm p-7"
            >
              <div className="flex gap-1">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-[#FF5A00] text-[#FF5A00]" />
                ))}
              </div>
              <p className="mt-4 text-sm text-[#52525B] leading-relaxed">"{r.text}"</p>
              <p className="mt-4 font-bold text-sm text-[#0A0A0A]">{r.name}</p>
              <p className="text-xs text-[#A1A1AA]">{r.car}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
